export default __webpack_public_path__ + "static/media/8.b564d76e.md";